import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { clearLcpPaint } from "../../lib/adoptLcpImage";

function scrollWindowToTop(): void {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/** Reset scroll on route changes; honor in-page hash anchors on the same URL. */
export function ScrollToTop(): null {
  const { pathname, hash } = useLocation();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    if (prevPath.current !== null && prevPath.current !== pathname) {
      // Shell LCP nodes are path-specific; drop them on client navigations.
      clearLcpPaint();
      document.getElementById("lcp-paint-style")?.remove();
    }
    prevPath.current = pathname;

    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const frame = requestAnimationFrame(() => {
        const target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        scrollWindowToTop();
      });
      return () => cancelAnimationFrame(frame);
    }

    scrollWindowToTop();
  }, [pathname, hash]);

  return null;
}
